import * as Yup from "yup";

const AddEditHolidaySchema = Yup.object().shape({
  date: Yup.date().required("Holiday date is required"),
  subject: Yup.string().required("Message is required"),
});

export default AddEditHolidaySchema;
